export const ATCGNFaqData = [
    {
        Requestor: [
            {
                id: 1,
                Question: "Which regions are covered under ATC GN?",
                Answer: `<p>ATC GN (Advanced Technology Center Global Network) team focuses on addressing learning needs across various regions, including AMERICAS, APAC, EMEA, and ATCP.</p>`
            },
            {
                id: 2,
                Question: "What are the learning services offered by ATC GN?",
                Answer: `<p>Customized Training Programs:Tailored to build skills or upskill/lateral workforce to meet project requirement.
                        <p>Calendar Sessions</p>
                        <p>Faculty/SME support</p>
                        </p>`        
                    
            },
            {
                id: 3,
                Question: "What are different types of trainings offered by ATC-GN?",
                Answer: `<p>ATC-GN provides comprehensive training programs across 5 key dimensions:
                        <ol>
                        <li>Gen-AI and emerging technologies</li>
                        <li>Platform/Technologies  (SAP, Oracle, Java and Cloud)</li>
                        <li>Industry</li>
                        <li>Professional Skills, Language & Culture Trainings, Sustainability etc.</li>
                        <li>Delivery Fundamentals (Delivery, Infrastructure Engineering, Security, Devops and SRE)</li>
                        </ol>
                        </p>`
            },
            {
                id: 4,
                Question: "What are the modes of training delivery?",
                Answer: `<p>The ATC-GN Team offers training sessions through the following mode:
                        <ul>
                        <li>Self Paced training</li>
                        <li>Virtual Instructor Lead Training</li>
                        <li>In-person Instructor Lead Training</li>
                        <li>Self-paced + SME connect</li>
                        </ul>
                        </p>`
            },
            {
                id: 5,
                Question: "I have requirement in my project to arrange training for my team, can you guide on the same?",
                Answer: `<p>Please raise a request using this link<a style="text-decoration:none" href="https://apps.powerapps.com/play/e/default-e0793d39-0939-496d-b129-198edd916feb/a/a717c9aa-f39d-4070-bdb5-e1e3d6fd50b4?tenantId=e0793d39-0939-496d-b129-198edd916feb&sourcetime=1732794644453&source=portal" target='_blank'> ATCGN Training Request Form - Power Apps</a></p>`
            },
            {
                id: 6,
                Question: "What is the standard batch size for any training?",
                Answer: `<p>Please note that expected batch size is 15 for Virtual training and  25 for classroom training.</p>`
            },
            {
                id: 7,
                Question: "Where can I find information about the various training programs offered by ATC GN?",
                Answer: `<p>To explore the various training programs offered by ATC GN, please refer to the <a style="text-decoration:none" href="https://atcgn.lkm.accenture.com/ATCGNCatalog/" target='_blank'>ATC GN e-catalogue.</a></p>`
            },
            {
                id: 8,
                Question: "What are the scheduled training hours?",
                Answer: `<p>Trainings are scheduled at a timezone best suited for trainers and trainees.</p>`
            }
        ],
        Participant: [
            {
                id: 1,
                Question: "What are the prerequisites for enrolling in a training program?",
                Answer: `<p>Prerequisites for training programs vary based on the specific course. For each virtual program, pre-reads, pre-assignments, and case studies will be provided well in advance.
                        <p>Certification courses may require certain skills and knowledge, such as prior experience in the field, completion of prerequisite courses, or a specific level of education.</p></p>`
            },
            {
                id: 2,
                Question: "What are the requirements for attending the virtual ATC-GN training program?",
                Answer: `<p>To attend the virtual ATC-GN training program, participants should have an active laptop or desktop and internet connectivity. Additionally, for nomination-based programs, approval from the supervisor is required to attend the virtual training.</p>`
            },
            {
                id: 3,
                Question: "Which software tools are necessary for attending Virtual ATC-GN training sessions?",
                Answer: `<p>Respective training POC's and trainers will guide you on the necessary technical requirements (softwares to be installed prior to the training (if needed), hardware, online platforms). Testing is recommeded to prevent technical issues during training.</p>`
            },
            {
                id: 4,
                Question: "How do you offer In-person training in ATC GN?",
                Answer: `<p>In-person training refers to a learning method where the instructor and participants are physically present in the same location. Faculty travel and accommodation must be pre-approved by the requesting business sponsor, who will also cover the associated travel and stay costs.</p>`
            },
            {
                id: 5,
                Question: "I wish to withdraw/cancel my nomination from ongoing training, can you guide me on the same?",
                Answer: `<p>Please click on the offering link provided by the training POC on Workday. Once you are on the Workday page, scroll down slightly until you see the option labeled "Drop Course."</p>`
            },
            {
                id: 6,
                Question: "Can I share my training materials with others?",
                Answer: `<p>No, you can not share the training material further as this helps protect the intellectual property of the content. Kindly reach out to your trainer or Training POC for further query.</p>`
            },
            {
                id: 7,
                Question: "What happens in case if I miss the training session?",
                Answer: `<p> If you need to leave the training early or miss a session, please inform the Trainer and Training POC as soon as possible. In some cases, we offer access to recorded content, so you can catch up on what you have missed. This is subject to prior approvals. In some cases we recomend you to attend the same training in the future.</p>`
            },
            {
                id: 8,
                Question: "How do I know if I am eligible for Industry Learnings?",
                Answer: `All ATC employees are required to complete Industry trainings for the industry that they are tagged to.</p>`
            },
            {
                id: 9,
                Question: "Where can I find the learning material required for Industry courses?",
                Answer: `<p>Please refer the link for your assigned Industry Courses:<a href="https://networks.learning.accenture.com" target='_blank'>https://networks.learning.accenture.com</a></p>`
            },
            {
                id: 10,
                Question: "Will I have access to the training materials after the course is over?",
                Answer: `<p>Yes, participants will have access to the training materials such as training recordings, or any resources shared during the training for a certain period post training completion. This will allow you to revisit key concepts at your convenience.</p>`
            },
            {
                id: 11,
                Question: "What should I do if I have training related queries post the session completion?",
                Answer: `<p>Please reach out to your trainer for training related guidance.</p>`
            }
        ]
    }
]